export const phaseStats = {
  total: 17000,
  verified: 16200,
  pending: 500,
  issues: 300,
  stickersIssued: 15850,
  todayScans: 1248,
  irregularities: 37
};

export const verificationStatusData = [
  { name: 'যাচাইকৃত', value: 16200, color: '#006a4e' },
  { name: 'অপেক্ষমাণ', value: 500, color: '#e08a00' },
  { name: 'তথ্যগত সমস্যা', value: 300, color: '#c62828' }
];

export const stickerProgress = [
  { month: 'অক্টো', issued: 1200 },
  { month: 'নভে', issued: 3900 },
  { month: 'ডিসে', issued: 7100 },
  { month: 'জানু', issued: 10400 },
  { month: 'ফেব্রু', issued: 13600 },
  { month: 'মার্চ', issued: 15850 }
];

export const dailyVerification = [
  { day: '০৬ মার্চ', valid: 980, invalid: 22 },
  { day: '০৭ মার্চ', valid: 1045, invalid: 31 },
  { day: '০৮ মার্চ', valid: 870, invalid: 18 },
  { day: '০৯ মার্চ', valid: 1120, invalid: 29 },
  { day: '১০ মার্চ', valid: 1180, invalid: 34 },
  { day: '১১ মার্চ', valid: 1205, invalid: 41 },
  { day: '১২ মার্চ', valid: 1211, invalid: 37 }
];

export const divisionVerification = [
  { division: 'রমনা', scans: 168, issues: 6 },
  { division: 'লালবাগ', scans: 121, issues: 4 },
  { division: 'মতিঝিল', scans: 176, issues: 5 },
  { division: 'ওয়ারী', scans: 139, issues: 3 },
  { division: 'তেজগাঁও', scans: 157, issues: 7 },
  { division: 'মিরপুর', scans: 214, issues: 5 },
  { division: 'গুলশান', scans: 149, issues: 4 },
  { division: 'উত্তরা', scans: 124, issues: 3 }
];

export interface MapPoint {
  name: string;
  lat: number;
  lng: number;
  scans: number;
  issues: number;
}

export const mapPoints: MapPoint[] = [
  { name: 'মিরপুর-১০ গোলচত্বর', lat: 23.8069, lng: 90.3687, scans: 96, issues: 2 },
  { name: 'মিরপুর-১১ বাসস্ট্যান্ড', lat: 23.8193, lng: 90.3654, scans: 54, issues: 1 },
  { name: 'ফার্মগেট মোড়', lat: 23.7576, lng: 90.3897, scans: 88, issues: 1 },
  { name: 'গুলশান-১ চত্বর', lat: 23.7806, lng: 90.4167, scans: 72, issues: 3 },
  { name: 'মহাখালী', lat: 23.7778, lng: 90.405, scans: 61, issues: 1 },
  { name: 'মতিঝিল শাপলা চত্বর', lat: 23.733, lng: 90.4172, scans: 94, issues: 2 },
  { name: 'শাহবাগ মোড়', lat: 23.7383, lng: 90.3958, scans: 77, issues: 4 },
  { name: 'তেজগাঁও সাতরাস্তা', lat: 23.7578, lng: 90.4005, scans: 58, issues: 3 },
  { name: 'লালবাগ কেল্লার মোড়', lat: 23.719, lng: 90.388, scans: 49, issues: 2 },
  { name: 'যাত্রাবাড়ী চৌরাস্তা', lat: 23.7104, lng: 90.4349, scans: 81, issues: 2 },
  { name: 'উত্তরা হাউজ বিল্ডিং', lat: 23.8759, lng: 90.3995, scans: 66, issues: 1 },
  { name: 'মোহাম্মদপুর বাসস্ট্যান্ড', lat: 23.7662, lng: 90.3589, scans: 52, issues: 1 },
  { name: 'বাড্ডা লিংক রোড', lat: 23.7808, lng: 90.4262, scans: 47, issues: 2 }
];
